export default __webpack_public_path__ + "static/media/up-arrow.256324a8.svg";